import { useEffect } from 'react';

export const useInstallPrompt = () => {
  useEffect(() => {
    window.addEventListener('beforeinstallprompt', async (e: any) => {
      await e.userChoice;
    });
  }, []);
};
